export default __webpack_public_path__ + "assets/2.22eed4c5.png";